// Rangos y resumen de la pantalla Licencias 3CX (funciones puras).
import type { Licencia3cx } from '../api/licencias3cx';

export type Rango = 'todas' | 'r25' | 'r45' | 'r90' | 'vencidas' | 'sincorreo';

// Regla de negocio: los dias para vencer se cuentan en Bogota, igual que los correos del servidor; no siguen la zona de Mi perfil.
const diaBogota = (d: Date) => {
  const p = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Bogota', year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
  return Date.parse(`${p}T00:00:00Z`);
};
export const diasHasta = (vence: string | null, ahora = new Date()) => (vence ? Math.round((diaBogota(new Date(vence)) - diaBogota(ahora)) / 86_400_000) : null);

const activa = (l: Licencia3cx) => l.estado === 'POR_VENCER' || l.estado === 'VENCIDA';

export function enRango(l: Licencia3cx, r: Rango, ahora = new Date()) {
  const d = diasHasta(l.vence, ahora);
  if (r === 'todas') return activa(l);
  if (r === 'sincorreo') return activa(l) && !l.empresa?.correo;
  if (d == null || !activa(l)) return false;
  if (r === 'vencidas') return d < 0;
  if (r === 'r25') return d >= 0 && d <= 25;
  if (r === 'r45') return d > 25 && d <= 45;
  return d > 45 && d <= 90;
}

export function resumen(ls: Licencia3cx[], ahora = new Date()) {
  const n = (r: Rango) => ls.filter((l) => enRango(l, r, ahora)).length;
  return { r25: n('r25'), r45: n('r45'), r90: n('r90'), vencidas: n('vencidas'), sincorreo: n('sincorreo'), todas: n('todas') };
}

export const tonoDias = (d: number | null) => (d == null ? undefined : d < 0 ? 'bad' : d <= 25 ? 'bad' : d <= 45 ? 'warn' : undefined);
